import React from 'react';
import {DropDownMenu, MenuItem, Paper, Checkbox} from 'material-ui';
import {inject, observer} from 'mobx-react';
import {observable, action, computed} from 'mobx';
import {GoogleMapLoader, GoogleMap, KmlLayer} from "react-google-maps";
import {proxyUrl} from '../libs/config';
import LeafletMap from "./common/LeafletMap";

@inject('markerStore')
@observer
class HazardMap extends React.Component {

  @observable selectedFolder = null;
  @observable selectedHazardLevel = null;
  @observable otherSettings = [];
  @observable river_network = false;
  @observable district = false;
  @observable gaun_nagar = false;

  @action onChangeFolder = (event, key, value) => this.selectedFolder = value;
  @action onChangeHazardLevel = (event, key, value) => this.selectedHazardLevel = value;
  @action onChangeOtherSettings = (value) => {
    let prev = this.otherSettings.filter(x => x === value)[0];
    if(prev){
      this.otherSettings = this.otherSettings.filter(x => x !== prev);
    }else{
      this.otherSettings.push(value);
    }
  };

  @computed get basinLatLng(){
    if(this.selectedFolder && this.selectedHazardLevel){
      switch(this.selectedFolder){
        case 'Mahakali': return {lat: 29.116634, lng: 80.220570};
        case 'Karnali': return {lat: 28.539149, lng: 81.249165};
        case 'Babai': return {lat: 28.395487, lng: 81.599355};
        case 'West Rapti': return {lat: 28.048812, lng: 81.876759};
        case 'Narayani': return {lat: 27.5825568,lng: 84.1827714};
        case 'Bagmati': return {lat: 27.096124, lng: 85.464482};
        case 'Kamala': return {lat: 26.7388402, lng: 86.0249067};
        case 'Koshi': return {lat: 26.721931, lng: 87.104066};
        case 'Kankai ': return {lat: 26.661139, lng: 87.877186};
        default: return {lat: 28.082787, lng: 84.499982};
      }
    }else{
      return {lat: 28.082787, lng: 84.499982};
    }
  }

  sortBasin = basins => {
    const standardOrder = ['Mahakali', 'Karnali', 'Babai', 'West Rapti', 'Narayani', 'Bagmati', 'Kamala', 'Koshi', 'Kankai'];
    const orderedBasin = [];
    // eslint-disable-next-line array-callback-return
    standardOrder.map(basin => {
      let x = basins.filter(b => b.name.indexOf(basin) > -1)[0];
      if (x) orderedBasin.push(x);
    });
    return orderedBasin;
  };

  @computed get getKmlLayers(){
    let layers = [];
    layers.push({url: `${proxyUrl}/overlays/watershed_wgs.kml`, style: {
        color: "#FF0000",
        weight: 1.5,
        fillOpacity: 0,
      }, alwaysDisplay: true});

    if(this.selectedFolder && this.selectedHazardLevel)
      layers.push({url: `${proxyUrl}/overlays/${this.selectedFolder}_${this.selectedHazardLevel}.kmz`, style: {
          color: "#0000FF",
          weight: 2,
          // fillOpacity: 0
        }, alwaysDisplay: false});

    if(this.river_network){
      layers.push({url: `${proxyUrl}/overlays/Hazard_Polygon_final.kml`, alwaysDisplay: false})
    }

    if(this.gaun_nagar){
      layers.push({url: `${proxyUrl}/overlays/gapa-napa.kmz`, alwaysDisplay: false})
    }

    return layers;
  };

  render() {
    const {markerStore} = this.props;
    let folders = markerStore.getFolderHierarchy;

    return (
      <div className="col-md-12" style={{marginBottom:'10px', padding:'0px'}}>
        <Paper className="col-md-3 hazard-setting">
          <table className="col-md-2" style={{width: '300px'}}>
            <tbody className="full-width">
            <tr className="full-width">
              <td style={{width:'35%'}}><h5 className="primart_text_color">Basin</h5></td>
              <td style={{width:'65%'}}>
                <DropDownMenu value={this.selectedFolder} onChange={this.onChangeFolder}>
                  <MenuItem value={null} primaryText='--'/>{
                  this.sortBasin(folders).map(folder => (
                    <MenuItem value={folder.name} primaryText={folder.name}/>
                  ))
                }</DropDownMenu>
              </td>
            </tr>
            <tr>
              <td><h5 className="primart_text_color">Hazard Level</h5></td>
              <td>
                <DropDownMenu value={this.selectedHazardLevel} onChange={this.onChangeHazardLevel}>
                  <MenuItem value={null} primaryText='--'/>
                  <MenuItem value='warning' primaryText='Warning Level'/>
                  <MenuItem value='danger' primaryText='Danger Level'/>
                  <MenuItem value='50' primaryText='50 Years'/>
                  <MenuItem value='100' primaryText='100 Years'/>
                  <MenuItem value='500' primaryText='500 Years'/>
                  <MenuItem value='1000' primaryText='1000 Years'/>
                </DropDownMenu>
              </td>
            </tr>
            <tr><td colSpan="2"><Checkbox onCheck={() => this.river_network = !this.river_network} label="River Network"/></td></tr>
            <tr><td colSpan="2"><Checkbox onCheck={() => this.district = !this.district} label="District"/></td></tr>
            <tr><td colSpan="2"><Checkbox onCheck={() => this.gaun_nagar = !this.gaun_nagar} label="Gaunpalika & Nagarpalika"/></td></tr>
            {/*<tr><td colSpan="2"><Checkbox onCheck={() => this.onChangeOtherSettings('nagarpalika')} label="Nagarpalika"/></td></tr>*/}
            </tbody>
          </table>
        </Paper>
        <Paper className="col-md-9" style={{height:'60vh', padding:'5px'}}>
          <LeafletMap id='hazard_map' markers={[]} center={this.basinLatLng} zoom={this.selectedFolder && this.selectedHazardLevel? 9 : 7} kmlLayers={this.getKmlLayers}/>
        </Paper>
      </div>
    );
  }
}

export default HazardMap;


// WEBPACK FOOTER //
// ./src/components/HazardMapLeaflet.js